import { render, staticRenderFns } from "./VoiceAgent.vue?vue&type=template&id=2760e9c3&scoped=true"
import script from "./VoiceAgent.vue?vue&type=script&lang=js"
export * from "./VoiceAgent.vue?vue&type=script&lang=js"
import style0 from "./VoiceAgent.vue?vue&type=style&index=0&id=2760e9c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2760e9c3",
  null
  
)

export default component.exports